import { Grid, Paper } from "@material-ui/core";
import React from "react";
import ContentGroup from "../../../components/ScheduleList/ContentGroup";

export default function ScheduleListGroup() {
    return (
        <Paper className="p-2 p-lg-3">
            <Grid container spacing={2}>
                <Grid item xs={12} lg={12}>
                    <ContentGroup />
                </Grid>
            </Grid>
        </Paper>
    );
}
